<template>
  <v-app>
    <Navbar />
    <router-view v-if="$store.state.initialLoadComplete"></router-view>
    <MessageSnackbar />
    <v-progress-circular v-if="$store.state.globalLoading" class="loading-circle" large indeterminate :size="90" :width="15" color="orange"></v-progress-circular>
  </v-app>
</template>

<script>
import Navbar from '@/components/Navbar'
import MessageSnackbar from '@/components/MessageSnackbar.vue'
import firebase from 'firebase'
export default {
  name: 'App',
  components: {
    Navbar,
    MessageSnackbar

  },
  data: () => ({

    //
  }),
  mounted() {

    this.initializeData()

  },
  methods: {

    initializeData() {


      //manage signed in vs. out signed out data requests
      firebase.auth().onAuthStateChanged(() => {

        //for signed in users upon login
        if (firebase.auth().currentUser != null) {
          this.$store.commit('globalLoadingSet', true)
          Promise.all([
            this.$store.dispatch('userDataSubscribe'), //onSnapshot userData
            this.$store.dispatch("availableDecksSubscribe"), //onSnapshsot decks
            this.$store.dispatch("userPracticeHistoryGet"), //single query
            this.$store.dispatch("userDailyProgressGet"), //single query
            this.$store.dispatch("contentPropsGet"),
            this.$store.dispatch("editorsGet")
          ]).then(() => {
            this.$store.commit('globalLoadingSet', false)
            this.$store.commit('initialLoadCompleteSet', true)
          })

        }
        else {
          this.$store.commit('initialLoadCompleteSet', true)
        }
      })

    }
  }
};
</script>
<style>
.round-card {
  border-radius: 25px;

}
.loading-circle {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
</style>
